import { render, staticRenderFns } from "./orderTakingList.vue?vue&type=template&id=67d91224"
import script from "./orderTakingList.vue?vue&type=script&lang=js"
export * from "./orderTakingList.vue?vue&type=script&lang=js"
import style0 from "./orderTakingList.vue?vue&type=style&index=0&id=67d91224&prod&lang=stylus"
import style1 from "./orderTakingList.vue?vue&type=style&index=1&id=67d91224&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports